import styled, { css } from 'styled-components';
import { mq, getTextType, px2rem } from '../../../stylesheets/tools';

const StyledEventDateA11y = styled.div`
  ${props =>
    props.showWeekday &&
    css`
      position: absolute;
      top: ${props.isBig ? '-40px' : '-20px'};
    `}
  ${props =>
    !props.showWeekday &&
    css`
      position: relative;
    `}
  display: inline-flex;
  justify-content: flex-end;

  ${props =>
    props.isBig &&
    css`
      .eventDate__startdate,
      .eventDate__enddate {
        width: ${px2rem('140px')};
        height: ${px2rem('140px')};
      }

      .eventDate__shape-wrapper {
        width: ${px2rem('140px')};
      }
    `}
  
  ${props =>
    props.isSmall &&
    css`
      .eventDate__startdate,
      .eventDate__enddate {
        width: ${px2rem('80px')};
        height: ${px2rem('80px')};

        .eventDate__day,
        .eventDate__month {
          font-size: ${px2rem('20px')}!important;
          line-height: 1.25 !important;
        }
        .eventDate__year {
          font-size: ${px2rem('12px')}!important;
          line-height: 1.25 !important;
        }
      }

      .eventDate__shape-wrapper {
        width: ${px2rem('80px')};
      }
    `}
  
  ${props =>
    !props.isBig &&
    !props.isSmall &&
    css`
      .eventDate__startdate,
      .eventDate__enddate {
        width: ${px2rem('90px')};
        height: ${px2rem('90px')};

        ${mq('m')} {
          width: ${px2rem('100px')};
          height: ${px2rem('100px')};
        }
      }

      .eventDate__shape-wrapper {
        width: ${px2rem('90px')};

        .eventDate__shape {
          position: relative;
          &:before,
          &:after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          &:before {
            content: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 role=%22img%22 aria-hidden=%22true%22 focusable=%22false%22 viewBox=%220%200%20164%20164%22%3E%3Cpath d=%22M2 35.855v120.926S2 162 6.625 162h150.75s4.625 0 4.625-5.22V7.219S162 2 157.375 2H37.43C36.543 2 2 35.105 2 35.855z%22 stroke=%22%23000%22 stroke-width=%223%22 fill=%22%23FFF%22 fill-rule=%22evenodd%22/%3E%3C/svg%3E');
          }
          &:after {
            display: none;
            content: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 role=%22img%22 aria-hidden=%22true%22 focusable=%22false%22 viewBox=%220%200%20164%20164%22%3E%3Cpath d=%22M2 35.855v120.926S2 162 6.625 162h150.75s4.625 0 4.625-5.22V7.219S162 2 157.375 2H37.43C36.543 2 2 35.105 2 35.855z%22 stroke=%22%23e8e8e8%22 stroke-width=%223%22 fill=%22%23FFF%22 fill-rule=%22evenodd%22/%3E%3C/svg%3E');
          }
        }

        ${mq('m')} {
          width: ${px2rem('100px')};
        }
      }
    `}
  .eventDate__startdate,
  .eventDate__enddate {
    position: relative;
    margin-right: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${mq('m')} {
      margin-right: 10px;
    }

    .eventDate__day,
    .eventDate__month {
      ${getTextType('tertiary')}
      text-transform: uppercase;
      position: relative;
    }

    .eventDate__year {
      ${getTextType('subline')}
      position: relative;
    }
  }

  .eventDate__enddate:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    width: 30px;
    height: 2px;
    background: #000;
    border-radius: 2px 0 0 2px;
    z-index: 1;
  }

  .eventDate__shape-wrapper {
    position: absolute;
    pointer-events: none;
    top: 0;
    z-index: -1;
    left: 0;
  }

  .eventDate__arrow-wrapper {
    position: absolute;
    width: 40px;
    
    ${props =>
      props.timeOnTop
        ? css`
            top: 15px;
            right: -20px;
          `
        : css`
            bottom: -5px;
            right: -2px;
            transform: rotate(90deg);
          `}

    ${mq('m')} {
      bottom: auto;
      width: 65px;
      top: 15px;
      right: -35px;
      transform: rotate(0deg);
    }

    ${props =>
      props.isTeaser &&
      !props.period &&
      css`
        top: auto;
        bottom: 25px;
        right: -15px;
        transform: rotate(0deg);
      `}
      ${props =>
        props.isTeaser &&
        !props.timeOnTop &&
        css`
          ${mq('m')} {
            width: 40px;
            top: auto;
            bottom: 13px;
            right: -20px;
          }
        `}
      ${props =>
        props.isTeaser &&
        props.timeOnTop &&
        css`
          ${mq('m')} {
            width: 40px;
            bottom: auto;
            right: -20px;
          }
        `}
    }
  }

  .eventDate__arrow,
  .eventDate__shape {
    position: relative;
    height: 0;
    width: 100%;

    svg {
      display: block;
      height: 100%;
      left: 0;
      overflow: visible !important;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .eventDate__arrow {
    padding-bottom: calc(32 / 98 * 100%);
  }

  .eventDate__shape {
    padding-bottom: calc(164 / 164 * 100%);
  }
`;

export default StyledEventDateA11y;
